import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { ProjectDetailsContext, ProjectStateLoadingContext } from './Context';
import { useRegisterProjectChat } from './hooks/useRegisterChat';

type Props = {
  children: React.ReactNode;
};

export const ProjectContainer = (props: Props) => {

  const params = useParams<{ projectId: string }>();
  const projectId = +params.projectId;

  const apiClient = useChatApiClient();

  const query = useQuery({
    queryKey: [`get:projects`, projectId],
    queryFn: async () => {
      return apiClient.projects.fetchProject({
        projectId,
      });
    },
  });

  useRegisterProjectChat({
    enabled: !!query.data,
    project: query.data ? {
      id: query.data.project.id,
      name: query.data.project.name,
      projectType: query.data.project.projectTypeId,
    } : null,
  });

  return (
    <ProjectStateLoadingContext.Provider value={!query.data || query.isLoading}>
      <ProjectDetailsContext.Provider value={{ query }}>
        {props.children}
      </ProjectDetailsContext.Provider>
    </ProjectStateLoadingContext.Provider>
  );
};

ProjectContainer.displayName = 'Project.Container';